module.exports = __webpack_public_path__ + "img/video3.ad4e8ac3.jpg";